export default __webpack_public_path__ + "static/media/home-startup-footer-down-bg.6dd2895e.jpg";